
export { default as MarkerPin01 } from "./MarkerPin01"